import React from "react";
//import ReactDOM from 'react-dom';
import axios from 'axios';
import Slider from "react-slick";
import  './Slidearrow.css';
import Products from '../Components/Products';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import  './Recommendforyou.css';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ProductsHome from "./ProductsHome";

class Recommendforyou extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : [],
            sub : [],
            list : []

        }
    }; 
    componentDidMount(){
      axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.recommended?pin='+localStorage.getItem('pin')), {
          headers : {
      'content-type': 'application/json'}
      })
      .then(response=>{
          this.setState({list:response.data.message})
          //console.log(response.data.data)  
      })
      .catch(response=>{
           //console.log(response+' api/method/ecom.api.item_list?item_group_route=products/aquarium-live-stocks')
      })
  } 
    render() {

      var obj = [...this.state.list];
      obj.sort((a,b) => b.stock - a.stock);

      
      var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        pauseOnHover: true,
         nextArrow: (
          <div>
            <div className="next-slick-arrow mob-d-none"> <ArrowForwardIosIcon/> </div>
          </div>
        ),
      prevArrow: (
          <div>
             <div className="next-slick-arrow mob-d-none"> <ArrowBackIosNewIcon/> </div>
          </div>
        ), 
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
                arrows: false,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
                arrows: false,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
              }
            }
          ]
    }
    if(this.state.list.length > 5)


         return <div className="hot-deal-area bg-light-gray pt-50px pb-20px pb-sm-40px mb-5">
         <div className="container">
             <div className="row">
                 <div className="col-md-12 arrival-area">
                     <div className="section-title">
                         <h2>Recommend For You</h2>
                         <ul className="nav nav-tabs sub-category recommend-link">
                                      <li className="nav-item">
                                          <a className="nav-link active recommend-link view-all-text"  href="/recommended-for-you">View All</a>
                                      </li>
                                  </ul>
                     </div>
                 </div>
             </div>

             <Slider {...settings}>
             {obj.map((item,k)=>{
                                      return(
              <ProductsHome key={k} data={item}/>






                               )
                              })} 


</Slider>
 
                 
             
         </div>
     </div>


     else
     return""
         

     }
    

 }
 export default Recommendforyou;